import React from 'react';
import MaskedInput from 'react-maskedinput';

// funções
import { validarData } from './../../Funcoes';

// componentes
import { Form } from 'react-bootstrap';

function InputData({
    data,
    onChange,
    placeholder=''
}){

    let dataRef = React.createRef();

    return <>
        <MaskedInput 
            placeholder={placeholder}
            mask="11/11/1111"
            ref={dataRef}
            value={(data === null)? '' : data.split('-').reverse().join('/')} 
            onChange={(e) => {
                data = e.target.value.split('_').join('').split('/').reverse().join('-');
                if(e.target.value === ''){
                    data = null;
                }
                onChange(data);
                // alterarDados({...dados});
            }}
            className={["form-control", validarData(data, 'invalid') ? 'is-invalid': ''].join(' ')}
        />
        { validarData(data, 'invalid') &&
            <Form.Control.Feedback type="invalid">Data inválida</Form.Control.Feedback>
        }
    </>
}

// retorna
export default InputData; 